function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1924(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 26.5,
    height: 9.83,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.22875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 4.915
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.83,
    width: 26.5,
    height: 31.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 25.705
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.59,
    width: 26.5,
    height: 34.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 58.795
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 76,
    width: 26.5,
    height: 46.19,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 99.095
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 122.18,
    width: 26.5,
    height: 51.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 147.835
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.49,
    width: 26.5,
    height: 55.96,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9444444444444446
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 201.47
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 229.45,
    width: 26.5,
    height: 56.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 257.7
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 285.96,
    width: 26.5,
    height: 61.24,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 316.58
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 347.2,
    width: 26.5,
    height: 65.52,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 379.96
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 412.71,
    width: 26.5,
    height: 67.3,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7857142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 446.35999999999996
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 480.01,
    width: 26.5,
    height: 69.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 514.53
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 549.06,
    width: 26.5,
    height: 73.88,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 586
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 622.93,
    width: 26.5,
    height: 77.07,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.25,
    y: 661.4649999999999
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 0,
    width: 41.67,
    height: 49.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.952857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.335,
    y: 24.675
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.17,
    y: 0,
    width: 41.7,
    height: 49.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.957142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 89.02000000000001,
    y: 24.675
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.87,
    y: 0,
    width: 43.1,
    height: 49.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.183333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.42000000000002,
    y: 24.675
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.97,
    y: 0,
    width: 44.16,
    height: 49.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.05,
    y: 24.675
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.13,
    y: 0,
    width: 45.8,
    height: 49.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 220.03,
    y: 24.675
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.94,
    y: 0,
    width: 47.28,
    height: 49.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.7542857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.58,
    y: 24.675
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.22,
    y: 0,
    width: 47.45,
    height: 49.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.93125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313.94500000000005,
    y: 24.675
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.67,
    y: 0,
    width: 49.05,
    height: 49.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.13125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.195,
    y: 24.675
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.72,
    y: 0,
    width: 49.27,
    height: 49.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.15875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 411.355,
    y: 24.675
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 0,
    width: 49.65,
    height: 49.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.825,
    y: 24.675
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.65,
    y: 0,
    width: 49.77,
    height: 49.35,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.53499999999997,
    y: 24.675
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.42,
    y: 0,
    width: 51.46,
    height: 49.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.16875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 561.15,
    y: 24.675
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.88,
    y: 0,
    width: 54.52,
    height: 49.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.16875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.14,
    y: 24.675
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.39,
    y: 0,
    width: 58.61,
    height: 49.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9350000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.6949999999999,
    y: 24.675
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 49.35,
    width: 61.03,
    height: 47.93,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.586
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 73.315
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 97.28,
    width: 61.03,
    height: 48.12,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.015
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 121.34
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 145.39,
    width: 61.03,
    height: 50.09,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.009
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 170.435
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 195.49,
    width: 61.03,
    height: 50.85,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 220.91500000000002
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 246.33,
    width: 61.03,
    height: 55.41,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9157142857142855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 274.035
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 301.74,
    width: 61.03,
    height: 57.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.24625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 330.725
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 359.71,
    width: 61.03,
    height: 66.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.62875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 392.745
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 425.77,
    width: 61.03,
    height: 66.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.548181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 459.06
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 492.36,
    width: 61.03,
    height: 66.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.171666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 525.695
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 559.02,
    width: 61.03,
    height: 70.21,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.171666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 594.125
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 629.24,
    width: 61.03,
    height: 70.76,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.718571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.015,
    y: 664.62
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.53,
    y: 49.35,
    width: 68.66,
    height: 67.65,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5166666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.86,
    y: 83.17500000000001
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.19,
    y: 49.35,
    width: 70.09,
    height: 67.65,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.235,
    y: 83.17500000000001
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.28,
    y: 49.35,
    width: 70.26,
    height: 67.65,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.41,
    y: 83.17500000000001
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.54,
    y: 49.35,
    width: 71.37,
    height: 67.65,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.664285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 332.225,
    y: 83.17500000000001
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.91,
    y: 49.35,
    width: 76.12,
    height: 67.65,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.45625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.97,
    y: 83.17500000000001
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 444.03,
    y: 49.35,
    width: 83.41,
    height: 67.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.45625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.73499999999996,
    y: 83.17500000000001
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.44,
    y: 49.35,
    width: 84.46,
    height: 67.65,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.664285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.6700000000001,
    y: 83.17500000000001
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.9,
    y: 49.35,
    width: 88.1,
    height: 67.65,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 655.9499999999999,
    y: 83.17500000000001
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.53,
    y: 117,
    width: 90.77,
    height: 69.05,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.508333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.915,
    y: 151.525
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.53,
    y: 186.05,
    width: 90.77,
    height: 69.08,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9079999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.915,
    y: 220.59
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.53,
    y: 255.12,
    width: 90.77,
    height: 71.26,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.876666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.915,
    y: 290.75
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.53,
    y: 326.38,
    width: 90.77,
    height: 75.18,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.915,
    y: 363.97
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.53,
    y: 401.56,
    width: 90.77,
    height: 90.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.043000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.915,
    y: 446.775
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.53,
    y: 491.99,
    width: 90.77,
    height: 100.45,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.128333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.915,
    y: 542.215
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.53,
    y: 592.44,
    width: 90.77,
    height: 107.56,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.128333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.915,
    y: 646.22
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.29,
    y: 117,
    width: 103.48,
    height: 134.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.246666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.03,
    y: 184.29500000000002
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.78,
    y: 117,
    width: 112.4,
    height: 134.59,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.97999999999996,
    y: 184.29500000000002
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.18,
    y: 117,
    width: 148.4,
    height: 134.59,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.235454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.38,
    y: 184.29500000000002
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.58,
    y: 117,
    width: 157.42,
    height: 134.59,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.43166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.2900000000001,
    y: 184.29500000000002
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.29,
    y: 251.58,
    width: 199.64,
    height: 141.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.583333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.11,
    y: 322.33000000000004
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.29,
    y: 393.08,
    width: 199.64,
    height: 143.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 35.9975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.11,
    y: 465.075
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 178.29,
    y: 537.08,
    width: 199.64,
    height: 162.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.583999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.11,
    y: 618.5400000000001
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.93,
    y: 251.58,
    width: 322.07,
    height: 215.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.99625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.965,
    y: 359.565
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.93,
    y: 467.55,
    width: 322.07,
    height: 232.45,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 46.489999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.965,
    y: 583.775
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1924);
export default __webpack_public_path__ + "static/media/1924.caaf1d18961963cea4e39dc50c5bd20d.svg";
export { ForwardRef as ReactComponent };